import { useEffect, useRef } from 'react';

const Cursor = () => {
  const cursorRef = useRef(null);
  const cursorDotRef = useRef(null);

  useEffect(() => {
    // Disable on touch devices
    if (window.matchMedia('(pointer: coarse)').matches) return;

    const cursor = cursorRef.current;
    const cursorDot = cursorDotRef.current;

    if (!cursor || !cursorDot) return;

    const moveCursor = (e) => {
      const { clientX, clientY } = e;

      // Position center dot and outer brackets
      cursor.style.transform = `translate(${clientX - 12}px, ${clientY - 12}px)`;
      cursorDot.style.transform = `translate(${clientX - 2}px, ${clientY - 2}px)`;
    };

    const handleMouseEnter = () => {
      cursor.style.transform = `${cursor.style.transform} scale(1.4)`;
      cursor.style.borderColor = 'rgba(255, 255, 255, 0.9)'; // pure white
      cursor.style.borderWidth = '1px';
      cursorDot.style.transform = `${cursorDot.style.transform} scale(0.5)`;
    };

    const handleMouseLeave = () => {
      cursor.style.transform = cursor.style.transform.replace(' scale(1.4)', '');
      cursor.style.borderColor = 'rgba(255, 255, 255, 0.2)';
      cursor.style.borderWidth = '0.5px';
      cursorDot.style.transform = cursorDot.style.transform.replace(' scale(0.5)', '');
    };

    window.addEventListener('mousemove', moveCursor);

    const setupInteractivity = () => {
      const elements = document.querySelectorAll('a, button, [role="button"], input, textarea, .about-card, .achievement-card, .project-card');
      elements.forEach((el) => {
        el.addEventListener('mouseenter', handleMouseEnter);
        el.addEventListener('mouseleave', handleMouseLeave);
      });
    };

    setupInteractivity();
    const interval = setInterval(setupInteractivity, 1500);

    return () => {
      window.removeEventListener('mousemove', moveCursor);
      clearInterval(interval);
    };
  }, []);

  return (
    <>
      {/* Outer bracket square reticle */}
      <div
        ref={cursorRef}
        className="hidden md:block fixed top-0 left-0 w-6 h-6 pointer-events-none z-[9999] border-[0.5px] border-white-pure/25 transition-transform duration-100 ease-out"
        style={{ transform: 'translate(-100px, -100px)' }}
      >
        {/* Cardinal crosshair ticks */}
        <div className="absolute top-1/2 left-0 w-1 h-[0.5px] bg-white-pure/40 -translate-y-1/2" />
        <div className="absolute top-1/2 right-0 w-1 h-[0.5px] bg-white-pure/40 -translate-y-1/2" />
        <div className="absolute top-0 left-1/2 w-[0.5px] h-1 bg-white-pure/40 -translate-x-1/2" />
        <div className="absolute bottom-0 left-1/2 w-[0.5px] h-1 bg-white-pure/40 -translate-x-1/2" />
      </div>

      {/* Center sharp dot */}
      <div
        ref={cursorDotRef}
        className="hidden md:block fixed top-0 left-0 w-1 h-1 bg-white-pure pointer-events-none z-[9999]"
        style={{ transform: 'translate(-100px, -100px)' }}
      />
    </>
  );
};

export default Cursor;
